import {
  apiGet,
  apiPost,
  apiPut,
  apiDelete,
} from '@/services/api/baseService';

export interface ModuleCatalogEntry {
  id: number;
  system_key: string;
  system_display_name: string;
  module_key: string | null;
  feature_code: string | null;
  name: string;
  purpose: string | null;
  functions: string | null;
  requirements_notes: string | null;
  route: string | null;
  is_custom: number;
  sort_order: number;
  is_active: number;
  created_at: string;
  updated_at: string;
  updated_by: number | null;
}

export interface CreateModuleCatalogEntryDto {
  system_key: string;
  system_display_name: string;
  module_key?: string | null;
  feature_code?: string | null;
  name: string;
  purpose?: string | null;
  functions?: string | null;
  requirements_notes?: string | null;
  route?: string | null;
  sort_order?: number;
}

export interface UpdateModuleCatalogEntryDto {
  system_display_name?: string;
  name?: string;
  purpose?: string | null;
  functions?: string | null;
  requirements_notes?: string | null;
  route?: string | null;
  sort_order?: number;
  is_active?: boolean;
}

export interface ModuleCatalogSyncResult {
  inserted: number;
  updated: number;
  total: number;
}

export const moduleCatalogService = {
  async list(search?: string): Promise<ModuleCatalogEntry[]> {
    const query = search ? `?search=${encodeURIComponent(search)}` : '';
    return apiGet<ModuleCatalogEntry[]>(`/api/crm/module-catalog${query}`);
  },

  async sync(): Promise<ModuleCatalogSyncResult> {
    return apiPost<ModuleCatalogSyncResult>('/api/crm/module-catalog/sync');
  },

  async create(dto: CreateModuleCatalogEntryDto): Promise<ModuleCatalogEntry> {
    return apiPost<ModuleCatalogEntry>('/api/crm/module-catalog', dto);
  },

  async update(id: number, dto: UpdateModuleCatalogEntryDto): Promise<ModuleCatalogEntry> {
    return apiPut<ModuleCatalogEntry>(`/api/crm/module-catalog/${id}`, dto);
  },

  async remove(id: number): Promise<void> {
    return apiDelete(`/api/crm/module-catalog/${id}`);
  },
};
